var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.96967 11.5303C0.676777 11.2374 0.676777 10.7626 0.96967 10.4697L5.43934 6L0.969669 1.53033C0.676776 1.23744 0.676776 0.762564 0.969669 0.46967C1.26256 0.176777 1.73744 0.176777 2.03033 0.46967L7.03033 5.46967C7.32322 5.76256 7.32322 6.23744 7.03033 6.53033L2.03033 11.5303C1.73744 11.8232 1.26256 11.8232 0.96967 11.5303Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrowRight);
export default __webpack_public_path__ + "static/media/carousel_arrow_right.573f79157eec9c84ca2315bffcbfa160.svg";
export { ForwardRef as ReactComponent };